import React, { useState } from "react";

const AutoCompleteDropdown = ({ suggestions, onSelect }) => {
  const [query, setQuery] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);

  // Handle input change
  const handleChange = (event) => {
    const value = event.target.value;
    setQuery(value);

    if (value === "") {
      onSelect(""); // Clear selected value in parent component
    }
    // Filter suggestions based on query
    const filtered = suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSuggestions(filtered);
    setShowSuggestions(true);
  };

  // Handle suggestion selection
  const handleSelect = (suggestion) => {
    setQuery(suggestion);
    // setSelectedSuggestion(suggestion);
    onSelect(suggestion);
    setShowSuggestions(false);
  };

  // Handle when user clicks outside the dropdown to close it
  const handleClickOutside = (event) => {
    if (!event.target.closest(".autocomplete-dropdown")) {
      setShowSuggestions(false);
      //setQuery("");
    }
  };

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="autocomplete-dropdown" style={{ position: "relative" }}>
      <input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder="Search..."
        className="autocomplete-input"
      />
      {showSuggestions && query && (
        <ul
          className="suggestions-list"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            backgroundColor: "white",
            border: "1px solid #ccc",
            listStyleType: "none",
            padding: 0,
            margin: 0,
            zIndex: 1000,
            maxHeight: "200px",
          }}
        >
          {filteredSuggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSelect(suggestion)}
              style={{ padding: "8px", cursor: "pointer" }}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteDropdown;
